(function() {
  "use strict";

  var root = document.getElementById('devHeaderRoot');
  if (!root) return;

  var wishlist = [];
  var cartData = null;
  var isUpdating = false;

  try {
    wishlist = JSON.parse(localStorage.getItem('devraksha_wishlist') || '[]');
  } catch(e) { wishlist = []; }

  // ===== UTILITIES =====
  function formatMoney(cents) {
    if (typeof cents !== 'number') return '₹0.00';
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function showToast(message, isError) {
    var toast = document.getElementById('devToast');
    var msgEl = document.getElementById('devToastMessage');
    if (!toast || !msgEl) return;
    msgEl.textContent = message;
    toast.className = 'dev-toast show' + (isError ? ' error' : '');
    clearTimeout(window._devToastTimer);
    window._devToastTimer = setTimeout(function() { toast.classList.remove('show'); }, 3000);
  }

  function saveWishlist() {
    localStorage.setItem('devraksha_wishlist', JSON.stringify(wishlist));
  }

  // ===== CART API =====
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(res) {
        if (!res.ok) throw new Error('Cart fetch failed');
        return res.json();
      });
  }

  function addToCart(variantId, quantity) {
    quantity = quantity || 1;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    }).then(function(res) {
      if (!res.ok) {
        return res.json().then(function(err) { throw new Error(err.description || 'Could not add to cart'); });
      }
      return res.json();
    });
  }

  function updateCartItem(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function(res) {
      if (!res.ok) throw new Error('Update failed');
      return res.json();
    });
  }

  // ===== RENDER CART DRAWER (THE FIX) =====
  function renderCartDrawer(cart) {
    var body = document.getElementById('devCartBody');
    var footer = document.getElementById('devCartFooter');
    var itemCount = document.getElementById('devCartItemCount');
    var subtotalEl = document.getElementById('devCartSubtotal');
    var totalEl = document.getElementById('devCartTotal');
    
    if (!body) return;

    cartData = cart;
    updateCartBadge(cart.item_count);

    if (itemCount) {
      itemCount.textContent = cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '');
    }

    // EMPTY CART
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="dev-cart-empty" id="devCartEmpty">' +
        '<svg width="80" height="80" fill="currentColor" viewBox="0 0 16 16"><path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5z"/></svg>' +
        '<h4>Your cart is empty</h4>' +
        '<p>Looks like you haven\'t added any sacred items yet.</p>' +
        '<a href="/collections/all" class="dev-btn-shop">Start Shopping</a>' +
        '</div>';
      if (footer) footer.style.display = 'none';
      return;
    }

    // HAS ITEMS - Build cart items HTML
    var itemsHtml = cart.items.map(function(item, idx) {
      var lineIndex = idx + 1;
      var imgHtml = item.image 
        ? '<img src="' + item.image + '" alt="' + (item.product_title || '') + '">'
        : '<div class="dev-cart-img-placeholder"><svg width="32" height="32" fill="#a3552a" viewBox="0 0 16 16"><path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0z"/></svg></div>';
      
      var variantText = item.variant_title && item.variant_title !== 'Default Title' 
        ? '<div class="dev-cart-item-variant">' + item.variant_title + '</div>' 
        : '';

      return '<div class="dev-cart-item" data-line="' + lineIndex + '">' +
        '<div class="dev-cart-item-img">' + imgHtml + '</div>' +
        '<div class="dev-cart-item-details">' +
        '<h4><a href="' + item.url + '">' + item.product_title + '</a></h4>' +
        variantText +
        '<div class="dev-cart-item-bottom">' +
        '<div class="dev-cart-qty">' +
        '<button type="button" data-action="decrease" data-line="' + lineIndex + '">−</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-action="increase" data-line="' + lineIndex + '">+</button>' +
        '</div>' +
        '<span class="dev-cart-item-price">' + formatMoney(item.final_line_price) + '</span>' +
        '<button type="button" class="dev-cart-item-remove" data-action="remove" data-line="' + lineIndex + '" title="Remove">' +
        '<svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/></svg>' +
        '</button></div></div></div>';
    }).join('');

    body.innerHTML = '<div class="dev-cart-items">' + itemsHtml + '</div>';

    // Update footer
    if (footer) {
      footer.style.display = 'block';
      
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      
      // Free shipping tracker
      var threshold = 49900; // ₹499 in cents
      var shippingNote = footer.querySelector('.dev-cart-shipping-note');
      if (shippingNote) {
        if (cart.total_price >= threshold) {
          shippingNote.className = 'dev-cart-shipping-note dev-cart-shipping-success';
          shippingNote.innerHTML = '✓ You qualify for FREE shipping!';
        } else {
          var remaining = threshold - cart.total_price;
          shippingNote.className = 'dev-cart-shipping-note';
          shippingNote.innerHTML = '🚚 Add <strong>' + formatMoney(remaining) + '</strong> more for FREE shipping!';
        }
      }
    }
  }

  // ===== UPDATE BADGES =====
  function updateCartBadge(count) {
    var badge = document.getElementById('devCartBadge');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  function updateWishlistBadge() {
    var badge = document.getElementById('devWishlistBadge');
    if (badge) {
      badge.textContent = wishlist.length;
      badge.style.display = wishlist.length > 0 ? 'flex' : 'none';
    }
  }

  // ===== SEARCH =====
  var searchOverlay = document.getElementById('devSearchOverlay');
  var searchInput = document.getElementById('devSearchInput');
  var searchResults = document.getElementById('devSearchResults');
  var searchSuggestions = document.getElementById('devSearchSuggestions');
  var searchBtn = document.getElementById('devSearchBtn');
  var searchClose = document.getElementById('devSearchClose');
  var searchDebounce = null;

  function openSearch() {
    if (searchOverlay) {
      searchOverlay.classList.add('active');
      document.body.classList.add('no-scroll');
      setTimeout(function() { if (searchInput) searchInput.focus(); }, 100);
    }
  }

  function closeSearch() {
    if (searchOverlay) searchOverlay.classList.remove('active');
    document.body.classList.remove('no-scroll');
    if (searchInput) searchInput.value = '';
    if (searchResults) searchResults.style.display = 'none';
    if (searchSuggestions) searchSuggestions.style.display = 'block';
  }

  function performSearch(query) {
    if (!searchResults) return;
    searchResults.style.display = 'block';
    searchResults.innerHTML = '<div class="dev-search-loading">Searching...</div>';
    if (searchSuggestions) searchSuggestions.style.display = 'none';

    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
      .then(function(res) { if (!res.ok) throw new Error(); return res.json(); })
      .then(function(data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) ? data.resources.results.products : [];
        if (products.length === 0) {
          searchResults.innerHTML = '<div class="dev-search-no-results">No products found for "' + query + '"</div>';
          return;
        }
        searchResults.innerHTML = products.map(function(p) {
          var imgHtml = p.featured_image && p.featured_image.url
            ? '<img src="' + p.featured_image.url + '" alt="" class="dev-search-result-img">'
            : '<div class="dev-search-result-img" style="display:flex;align-items:center;justify-content:center;"><svg width="24" height="24" fill="#a3552a" viewBox="0 0 16 16"><path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0z"/></svg></div>';
          var priceHtml = p.price ? '<p>' + p.price + '</p>' : '';
          return '<a href="' + p.url + '" class="dev-search-result-item">' + imgHtml +
            '<div class="dev-search-result-info"><h5>' + p.title + '</h5>' + priceHtml + '</div></a>';
        }).join('');
      })
      .catch(function() {
        searchResults.innerHTML = '<div class="dev-search-no-results">Search unavailable. Try the main search page.</div>';
      });
  }

  if (searchBtn) searchBtn.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchOverlay) searchOverlay.addEventListener('click', function(e) { if (e.target === searchOverlay) closeSearch(); });

  if (searchInput) {
    searchInput.addEventListener('input', function() {
      var query = this.value.trim();
      clearTimeout(searchDebounce);
      if (query.length < 2) {
        if (searchResults) searchResults.style.display = 'none';
        if (searchSuggestions) searchSuggestions.style.display = 'block';
        return;
      }
      searchDebounce = setTimeout(function() { performSearch(query); }, 300);
    });
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (this.value.trim()) window.location.href = '/search?q=' + encodeURIComponent(this.value.trim());
      }
    });
  }

  document.addEventListener('click', function(e) {
    var tag = e.target.closest('[data-search]');
    if (tag) {
      e.preventDefault();
      if (searchInput) { searchInput.value = tag.getAttribute('data-search'); searchInput.dispatchEvent(new Event('input')); }
    }
  });

  // ===== CART DRAWER =====
  var cartDrawer = document.getElementById('devCartDrawer');
  var cartOverlay = document.getElementById('devCartOverlay');
  var cartBtn = document.getElementById('devCartBtn');
  var cartClose = document.getElementById('devCartClose');
  var cartContinue = document.getElementById('devCartContinue');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('active');
    if (cartOverlay) cartOverlay.classList.add('active');
    document.body.classList.add('no-scroll');
    
    // Fetch fresh cart and re-render
    if (!isUpdating) {
      getCart().then(renderCartDrawer).catch(function(err) { console.error('Cart error:', err); });
    }
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('active');
    if (cartOverlay) cartOverlay.classList.remove('active');
    document.body.classList.remove('no-scroll');
  }

  if (cartBtn) cartBtn.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartContinue) cartContinue.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // Cart item actions (quantity +/-, remove)
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var drawer = btn.closest('.dev-cart-drawer');
    if (!drawer || drawer.id === 'devWishlistDrawer') return;
    
    var action = btn.getAttribute('data-action');
    var line = parseInt(btn.getAttribute('data-line'));
    if (isUpdating) return;
    isUpdating = true;

    if (action === 'increase' || action === 'decrease') {
      var qtySpan = btn.parentElement.querySelector('span');
      var currentQty = parseInt(qtySpan.textContent);
      var newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
      
      updateCartItem(line, newQty)
        .then(function(cart) {
          renderCartDrawer(cart);
          isUpdating = false;
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        })
        .catch(function() {
          showToast('Error updating cart', true);
          isUpdating = false;
        });
    } else if (action === 'remove') {
      updateCartItem(line, 0)
        .then(function(cart) {
          renderCartDrawer(cart);
          isUpdating = false;
          showToast('Item removed');
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        })
        .catch(function() {
          showToast('Error removing item', true);
          isUpdating = false;
        });
    }
  });

  // ===== WISHLIST =====
  var wishlistDrawer = document.getElementById('devWishlistDrawer');
  var wishlistOverlay = document.getElementById('devWishlistOverlay');
  var wishlistBtn = document.getElementById('devWishlistBtn');
  var wishlistClose = document.getElementById('devWishlistClose');

  function openWishlist() {
    if (wishlistDrawer) wishlistDrawer.classList.add('active');
    if (wishlistOverlay) wishlistOverlay.classList.add('active');
    document.body.classList.add('no-scroll');
    renderWishlistDrawer();
  }

  function closeWishlist() {
    if (wishlistDrawer) wishlistDrawer.classList.remove('active');
    if (wishlistOverlay) wishlistOverlay.classList.remove('active');
    document.body.classList.remove('no-scroll');
  }

  function renderWishlistDrawer() {
    var body = document.getElementById('devWishlistBody');
    if (!body) return;
    
    if (wishlist.length === 0) {
      body.innerHTML = '<div class="dev-cart-empty">' +
        '<svg width="80" height="80" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/></svg>' +
        '<h4>Your wishlist is empty</h4><p>Save your favorite sacred items</p>' +
        '<a href="/collections/all" class="dev-btn-shop">Browse Products</a></div>';
      return;
    }
    
    var countEl = document.getElementById('devWishlistCount');
    if (countEl) countEl.textContent = wishlist.length + ' item' + (wishlist.length > 1 ? 's' : '');
    
    body.innerHTML = '<div class="dev-cart-items">' + wishlist.map(function(item, index) {
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + (item.name || '') + '">'
        : '<div class="dev-cart-img-placeholder"><svg width="28" height="28" fill="#a3552a" viewBox="0 0 16 16"><path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0z"/></svg></div>';
      return '<div class="dev-cart-item">' +
        '<div class="dev-cart-item-img">' + imgHtml + '</div>' +
        '<div class="dev-cart-item-details"><h4>' + (item.url ? '<a href="' + item.url + '">' + item.name + '</a>' : item.name) + '</h4>' +
        '<span class="dev-cart-item-price">' + formatMoney(item.price) + '</span></div>' +
        '<div class="dev-wishlist-actions">' +
        '<button class="dev-btn-wishlist-cart" data-wishlist-cart="' + index + '">Add to Cart</button>' +
        '<button class="dev-btn-wishlist-remove" data-wishlist-remove="' + index + '">Remove</button>' +
        '</div></div>';
    }).join('') + '</div>';
  }

  if (wishlistBtn) wishlistBtn.addEventListener('click', openWishlist);
  if (wishlistClose) wishlistClose.addEventListener('click', closeWishlist);
  if (wishlistOverlay) wishlistOverlay.addEventListener('click', closeWishlist);

  document.addEventListener('click', function(e) {
    var addToCartBtn = e.target.closest('[data-wishlist-cart]');
    var removeBtn = e.target.closest('[data-wishlist-remove]');
    
    if (addToCartBtn) {
      var index = parseInt(addToCartBtn.getAttribute('data-wishlist-cart'));
      var item = wishlist[index];
      if (!item || !item.variant_id) { showToast('Cannot add to cart', true); return; }
      
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding...';
      
      addToCart(item.variant_id, 1)
        .then(function() { return getCart(); })
        .then(function(cart) {
          renderCartDrawer(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          wishlist.splice(index, 1);
          saveWishlist();
          updateWishlistBadge();
          renderWishlistDrawer();
          showToast('✓ ' + item.name + ' added to cart');
          closeWishlist();
          setTimeout(openCart, 300);
        })
        .catch(function(err) {
          showToast(err.message || 'Could not add', true);
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Add to Cart';
        });
    } else if (removeBtn) {
      var index = parseInt(removeBtn.getAttribute('data-wishlist-remove'));
      var name = wishlist[index] ? wishlist[index].name : 'Item';
      wishlist.splice(index, 1);
      saveWishlist();
      updateWishlistBadge();
      renderWishlistDrawer();
      showToast(name + ' removed from wishlist');
    }
  });

  // ===== GLOBAL APIs =====
  window.DevrakshaCart = {
    add: function(variantId, quantity, productName) {
      quantity = quantity || 1;
      return addToCart(variantId, quantity)
        .then(function() { return getCart(); })
        .then(function(cart) {
          renderCartDrawer(cart);
          updateCartBadge(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          showToast('✓ ' + (productName || 'Item') + ' added to cart');
          return cart;
        });
    },
    open: openCart,
    close: closeCart,
    refresh: function() { return getCart().then(renderCartDrawer); }
  };

  window.DevrakshaWishlist = {
    add: function(productId, variantId, name, price, image, url) {
      if (wishlist.find(function(i) { return i.id === productId; })) { showToast('Already in wishlist'); return false; }
      wishlist.push({ id: productId, variant_id: variantId, name: name, price: price, image: image, url: url });
      saveWishlist();
      updateWishlistBadge();
      showToast('♡ ' + name + ' added to wishlist');
      return true;
    },
    remove: function(productId) {
      var idx = wishlist.findIndex(function(i) { return i.id === productId; });
      if (idx > -1) { wishlist.splice(idx, 1); saveWishlist(); updateWishlistBadge(); return true; }
      return false;
    },
    toggle: function(productId, variantId, name, price, image, url) {
      if (wishlist.find(function(i) { return i.id === productId; })) { return !this.remove(productId); }
      return this.add(productId, variantId, name, price, image, url);
    },
    has: function(productId) { return !!wishlist.find(function(i) { return i.id === productId; }); },
    open: openWishlist,
    close: closeWishlist,
    getAll: function() { return wishlist.slice(); }
  };

  // ===== MOBILE NAV =====
  var mobileToggle = document.getElementById('devMobileToggle');
  var mainNav = document.getElementById('devNav');
  var navClose = document.getElementById('devNavClose');
  var navOverlay = document.getElementById('devNavOverlay');

  function closeNav() {
    if (mainNav) mainNav.classList.remove('active');
    if (navOverlay) navOverlay.classList.remove('active');
    if (mobileToggle) mobileToggle.classList.remove('active');
    document.body.classList.remove('no-scroll');
  }

  if (mobileToggle) {
    mobileToggle.addEventListener('click', function() {
      if (mainNav.classList.contains('active')) closeNav();
      else {
        mainNav.classList.add('active');
        navOverlay.classList.add('active');
        mobileToggle.classList.add('active');
        document.body.classList.add('no-scroll');
      }
    });
  }

  if (navClose) navClose.addEventListener('click', closeNav);
  if (navOverlay) navOverlay.addEventListener('click', closeNav);

  document.addEventListener('click', function(e) {
    var link = e.target.closest('[data-has-dropdown]');
    if (link && window.innerWidth <= 992) {
      e.preventDefault();
      var dropdown = link.nextElementSibling;
      if (dropdown) dropdown.classList.toggle('active');
    }
  });

  // ===== STICKY HEADER =====
  var devHeader = document.getElementById('devHeader');
  if (devHeader && devHeader.classList.contains('dev-header--sticky')) {
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 50) devHeader.classList.add('scrolled');
      else devHeader.classList.remove('scrolled');
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { closeSearch(); closeCart(); closeWishlist(); closeNav(); }
  });

  window.addEventListener('resize', function() {
    if (window.innerWidth > 992) closeNav();
  });

  // ===== INIT =====
  getCart()
    .then(function(cart) { 
      updateCartBadge(cart.item_count); 
      cartData = cart; 
    })
    .catch(function(err) { console.error('Initial cart load failed:', err); });
  
  updateWishlistBadge();

})(); 

// (function () {
//   "use strict";

//   var root = document.getElementById('devHeaderRoot');
//   if (!root) return;

//   /* ===== STATE ===== */
//   var wishlist = [];
//   try {
//     wishlist = JSON.parse(localStorage.getItem('devraksha_wishlist') || '[]');
//   } catch (e) { wishlist = []; }

//   var searchDebounceTimer = null;
//   var SCROLL_LOCK = 'dev-no-scroll'; /* must match CSS body.dev-no-scroll */

//   /* ===== UTILITIES ===== */
//   function formatMoney(cents) {
//     var val = (cents / 100).toFixed(2);
//     return '\u20B9' + Number(val).toLocaleString('en-IN', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     });
//   }

//   function showToast(message) {
//     var toast = document.getElementById('devToast');
//     if (!toast) return;
//     var msgEl = document.getElementById('devToastMessage');
//     if (msgEl) msgEl.textContent = message;
//     toast.classList.add('show');
//     clearTimeout(window._devToastTimer);
//     window._devToastTimer = setTimeout(function () {
//       toast.classList.remove('show');
//     }, 3000);
//   }

//   function saveWishlist() {
//     try {
//       localStorage.setItem('devraksha_wishlist', JSON.stringify(wishlist));
//     } catch (e) { /* storage full / private mode */ }
//   }

//   function setExpanded(btn, state) {
//     if (btn) btn.setAttribute('aria-expanded', state ? 'true' : 'false');
//   }

//   function updateBadges() {
//     var wishBadge = document.getElementById('devWishlistBadge');
//     if (wishBadge) {
//       wishBadge.textContent = wishlist.length;
//       wishBadge.setAttribute('data-count', wishlist.length);
//       wishBadge.style.display = wishlist.length > 0 ? 'flex' : 'none';
//     }
//   }

//   function updateCartBadge() {
//     fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
//       .then(function (res) { return res.json(); })
//       .then(function (cart) {
//         var badge = document.getElementById('devCartBadge');
//         if (badge) {
//           badge.textContent = cart.item_count;
//           badge.setAttribute('data-count', cart.item_count);
//           badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
//         }
//       })
//       .catch(function () { });
//   }

//   /* ===== SEARCH ===== */
//   var searchOverlay = document.getElementById('devSearchOverlay');
//   var searchInput = document.getElementById('devSearchInput');
//   var searchResults = document.getElementById('devSearchResults');
//   var searchSuggestions = document.getElementById('devSearchSuggestions');
//   var searchBtn = document.getElementById('devSearchBtn');

//   function openSearch() {
//     if (!searchOverlay) return;
//     searchOverlay.classList.add('active');
//     setExpanded(searchBtn, true);
//     document.body.classList.add(SCROLL_LOCK);
//     setTimeout(function () { if (searchInput) searchInput.focus(); }, 300);
//   }

//   function closeSearch() {
//     if (!searchOverlay) return;
//     searchOverlay.classList.remove('active');
//     setExpanded(searchBtn, false);
//     document.body.classList.remove(SCROLL_LOCK);
//     if (searchInput) searchInput.value = '';
//     if (searchResults) searchResults.style.display = 'none';
//     if (searchSuggestions) searchSuggestions.style.display = 'block';
//   }

//   if (searchBtn) searchBtn.addEventListener('click', openSearch);

//   var searchClose = document.getElementById('devSearchClose');
//   if (searchClose) searchClose.addEventListener('click', closeSearch);

//   if (searchOverlay) {
//     searchOverlay.addEventListener('click', function (e) {
//       if (e.target === searchOverlay) closeSearch();
//     });
//   }

//   if (searchInput) {
//     searchInput.addEventListener('input', function () {
//       var query = this.value.trim();
//       clearTimeout(searchDebounceTimer);

//       if (query.length < 2) {
//         if (searchResults) searchResults.style.display = 'none';
//         if (searchSuggestions) searchSuggestions.style.display = 'block';
//         return;
//       }

//       searchDebounceTimer = setTimeout(function () { performSearch(query); }, 300);
//     });

//     searchInput.addEventListener('keydown', function (e) {
//       if (e.key === 'Enter') {
//         e.preventDefault();
//         if (this.value.trim().length > 0) {
//           var form = this.closest('form');
//           if (form) form.submit();
//         }
//       }
//     });
//   }

//   function performSearch(query) {
//     if (searchSuggestions) searchSuggestions.style.display = 'none';
//     if (searchResults) {
//       searchResults.style.display = 'block';
//       searchResults.innerHTML = '<div class="dev-search-loading">Searching...</div>';
//     }

//     fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
//       '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
//       .then(function (res) { return res.json(); })
//       .then(function (data) {
//         var products = (data.resources && data.resources.results && data.resources.results.products) ? data.resources.results.products : [];
//         if (!searchResults) return;

//         if (products.length === 0) {
//           searchResults.innerHTML = '<div class="dev-search-no-results">No products found for "' + query + '"</div>';
//           return;
//         }

//         searchResults.innerHTML = products.map(function (p) {
//           var imgHtml = (p.featured_image && p.featured_image.url)
//             ? '<img src="' + p.featured_image.url + '" alt="" class="dev-search-result-img" loading="lazy">'
//             : '<div class="dev-search-result-img" style="display:flex;align-items:center;justify-content:center;"><svg width="24" height="24" fill="#a3552a" viewBox="0 0 16 16"><path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0z"/></svg></div>';

//           return '<a href="' + p.url + '" class="dev-search-result-item">' +
//             imgHtml +
//             '<div class="dev-search-result-info">' +
//             '<h5>' + p.title + '</h5>' +
//             '<p>' + (p.price || '') + '</p>' +
//             '</div></a>';
//         }).join('');
//       })
//       .catch(function () {
//         if (searchResults) searchResults.innerHTML = '<div class="dev-search-no-results">Search failed. Please try again.</div>';
//       });
//   }

//   root.querySelectorAll('[data-search]').forEach(function (link) {
//     link.addEventListener('click', function (e) {
//       e.preventDefault();
//       if (searchInput) {
//         searchInput.value = this.getAttribute('data-search');
//         searchInput.dispatchEvent(new Event('input'));
//       }
//     });
//   });

//   /* ===== CART ===== */
//   var cartDrawer = document.getElementById('devCartDrawer');
//   var cartOverlay = document.getElementById('devCartOverlay');
//   var cartBtn = document.getElementById('devCartBtn');
//   var cartClose = document.getElementById('devCartClose');
//   var cartContinue = document.getElementById('devCartContinue');

//   function openCart() {
//     if (cartDrawer) cartDrawer.classList.add('active');
//     if (cartOverlay) cartOverlay.classList.add('active');
//     setExpanded(cartBtn, true);
//     document.body.classList.add(SCROLL_LOCK);
//   }

//   function closeCart() {
//     if (cartDrawer) cartDrawer.classList.remove('active');
//     if (cartOverlay) cartOverlay.classList.remove('active');
//     setExpanded(cartBtn, false);
//     document.body.classList.remove(SCROLL_LOCK);
//   }

//   if (cartBtn) cartBtn.addEventListener('click', openCart);
//   if (cartClose) cartClose.addEventListener('click', closeCart);
//   if (cartContinue) cartContinue.addEventListener('click', closeCart);
//   if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

//   /* Cart qty / remove (event delegation) */
//   document.addEventListener('click', function (e) {
//     var btn = e.target.closest('[data-action]');
//     if (!btn || !btn.closest('#devCartDrawer')) return;

//     var action = btn.getAttribute('data-action');
//     var line = btn.getAttribute('data-line');

//     if (action === 'increase' || action === 'decrease') {
//       var qtySpan = btn.parentElement.querySelector('span');
//       var currentQty = parseInt(qtySpan.textContent, 10) || 1;
//       var newQty = action === 'increase' ? currentQty + 1 : currentQty - 1;
//       updateCartItem(line, newQty);
//     } else if (action === 'remove') {
//       updateCartItem(line, 0);
//     }
//   });

//   function updateCartItem(line, quantity) {
//     fetch('/cart/change.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ line: line, quantity: quantity })
//     })
//       .then(function (res) { return res.json(); })
//       .then(function () { window.location.reload(); })
//       .catch(function () { showToast('Error updating cart'); });
//   }

//   document.addEventListener('cart:updated', updateCartBadge);

//   /* ===== WISHLIST ===== */
//   var wishlistDrawer = document.getElementById('devWishlistDrawer');
//   var wishlistOverlay = document.getElementById('devWishlistOverlay');
//   var wishlistBtn = document.getElementById('devWishlistBtn');
//   var wishlistClose = document.getElementById('devWishlistClose');

//   function openWishlist() {
//     if (wishlistDrawer) wishlistDrawer.classList.add('active');
//     if (wishlistOverlay) wishlistOverlay.classList.add('active');
//     setExpanded(wishlistBtn, true);
//     document.body.classList.add(SCROLL_LOCK);
//     renderWishlist();
//   }

//   function closeWishlist() {
//     if (wishlistDrawer) wishlistDrawer.classList.remove('active');
//     if (wishlistOverlay) wishlistOverlay.classList.remove('active');
//     setExpanded(wishlistBtn, false);
//     document.body.classList.remove(SCROLL_LOCK);
//   }

//   if (wishlistBtn) wishlistBtn.addEventListener('click', openWishlist);
//   if (wishlistClose) wishlistClose.addEventListener('click', closeWishlist);
//   if (wishlistOverlay) wishlistOverlay.addEventListener('click', closeWishlist);

//   function renderWishlist() {
//     var itemsEl = document.getElementById('devWishlistItems');
//     var emptyEl = document.getElementById('devWishlistEmpty');
//     var countEl = document.getElementById('devWishlistCount');
//     if (!itemsEl || !emptyEl || !countEl) return;

//     if (wishlist.length === 0) {
//       emptyEl.style.display = 'block';
//       itemsEl.style.display = 'none';
//       countEl.textContent = '0 items';
//       return;
//     }

//     emptyEl.style.display = 'none';
//     itemsEl.style.display = 'block';
//     countEl.textContent = wishlist.length + ' item' + (wishlist.length > 1 ? 's' : '');

//     itemsEl.innerHTML = wishlist.map(function (item, index) {
//       var imgHtml = item.image
//         ? '<img src="' + item.image + '" alt="" loading="lazy">'
//         : '<div class="dev-cart-img-placeholder"><svg width="28" height="28" fill="#a3552a" viewBox="0 0 16 16"><path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0z"/></svg></div>';

//       return '<div class="dev-cart-item">' +
//         '<div class="dev-cart-item-img">' + imgHtml + '</div>' +
//         '<div class="dev-cart-item-details">' +
//         '<h4>' + (item.name || 'Product') + '</h4>' +
//         '<span class="dev-cart-item-price">' + formatMoney(item.price || 0) + '</span>' +
//         '</div>' +
//         '<div class="dev-wishlist-actions">' +
//         '<button class="dev-btn-wishlist-cart" data-wishlist-cart="' + index + '">Add to Cart</button>' +
//         '<button class="dev-btn-wishlist-remove" data-wishlist-remove="' + index + '">Remove</button>' +
//         '</div></div>';
//     }).join('');
//   }

//   document.addEventListener('click', function (e) {
//     var toCartBtn = e.target.closest('[data-wishlist-cart]');
//     var removeBtn = e.target.closest('[data-wishlist-remove]');

//     if (toCartBtn) {
//       moveToCart(parseInt(toCartBtn.getAttribute('data-wishlist-cart'), 10));
//     } else if (removeBtn) {
//       removeFromWishlist(parseInt(removeBtn.getAttribute('data-wishlist-remove'), 10));
//     }
//   });

//   /* Global hook for product pages */
//   window.devAddToWishlist = function (productId, name, price, image, url) {
//     var exists = wishlist.some(function (i) { return String(i.id) === String(productId); });
//     if (exists) { showToast('Already in your wishlist'); return; }
//     wishlist.push({ id: productId, name: name, price: price, image: image, url: url });
//     saveWishlist();
//     updateBadges();
//     renderWishlist();
//     showToast('\u2665 ' + name + ' added to wishlist');
//   };

//   function moveToCart(index) {
//     var item = wishlist[index];
//     if (!item) return;

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id: item.id, quantity: 1 })
//     })
//       .then(function (res) {
//         if (res.ok) {
//           wishlist.splice(index, 1);
//           saveWishlist();
//           updateBadges();
//           renderWishlist();
//           closeWishlist();
//           updateCartBadge();
//           showToast('\u2713 ' + item.name + ' added to cart');
//           setTimeout(openCart, 300);
//         } else {
//           showToast('Could not add to cart');
//         }
//       })
//       .catch(function () { showToast('Error adding to cart'); });
//   }

//   function removeFromWishlist(index) {
//     var item = wishlist[index];
//     if (!item) return;
//     wishlist.splice(index, 1);
//     saveWishlist();
//     updateBadges();
//     renderWishlist();
//     showToast(item.name + ' removed from wishlist');
//   }

//   /* ===== MOBILE NAV ===== */
//   var mobileToggle = document.getElementById('devMobileToggle');
//   var mainNav = document.getElementById('devNav');
//   var navClose = document.getElementById('devNavClose');
//   var navOverlay = document.getElementById('devNavOverlay');

//   function openNav() {
//     if (!mainNav) return;
//     mainNav.classList.add('active');
//     if (navOverlay) navOverlay.classList.add('active');
//     if (mobileToggle) mobileToggle.classList.add('active');
//     setExpanded(mobileToggle, true);
//     document.body.classList.add(SCROLL_LOCK);
//   }

//   function closeNav() {
//     if (mainNav) mainNav.classList.remove('active');
//     if (navOverlay) navOverlay.classList.remove('active');
//     if (mobileToggle) mobileToggle.classList.remove('active');
//     setExpanded(mobileToggle, false);
//     document.body.classList.remove(SCROLL_LOCK);
//   }

//   if (mobileToggle) {
//     mobileToggle.addEventListener('click', function () {
//       if (mainNav && mainNav.classList.contains('active')) closeNav();
//       else openNav();
//     });
//   }

//   if (navClose) navClose.addEventListener('click', closeNav);
//   if (navOverlay) navOverlay.addEventListener('click', closeNav);

//   /* Mobile dropdown toggle + close menu after choosing a link */
//   root.addEventListener('click', function (e) {
//     var dropdownLink = e.target.closest('[data-has-dropdown]');
//     if (dropdownLink && window.innerWidth <= 992) {
//       e.preventDefault();
//       var dropdown = dropdownLink.nextElementSibling;
//       if (dropdown) dropdown.classList.toggle('active');
//       return;
//     }

//     var navAnchor = e.target.closest('.dev-nav a');
//     if (navAnchor && window.innerWidth <= 992) closeNav();
//   });

//   /* ===== STICKY HEADER ===== */
//   var devHeader = document.getElementById('devHeader');
//   if (devHeader && devHeader.classList.contains('dev-header--sticky')) {
//     window.addEventListener('scroll', function () {
//       devHeader.classList.toggle('scrolled', window.pageYOffset > 50);
//     }, { passive: true });
//   }

//   /* ===== ESC KEY ===== */
//   document.addEventListener('keydown', function (e) {
//     if (e.key === 'Escape') {
//       closeSearch();
//       closeCart();
//       closeWishlist();
//       closeNav();
//     }
//   });

//   /* ===== RESIZE ===== */
//   window.addEventListener('resize', function () {
//     if (window.innerWidth > 992) {
//       closeNav();
//       root.querySelectorAll('.dev-dropdown').forEach(function (d) {
//         d.classList.remove('active');
//       });
//     }
//   });

//   /* ===== INIT ===== */
//   updateBadges();
//   updateCartBadge();
// })();